<div class="">
    <!------------------------------------------TITLE----------------------------------------------->
 <div class="title-box uk-border-rounded p-1">
    <!-- <div class="head-card p-1 inner-title-box">
      <h1 class="title-text text-center font-weight-bold">
        contact us
      </h1>
      <div class="text-right">
        <h5 class="text-light">
          <span class="sub-menu" routerLink="/home-page">Home </span>&nbsp;&nbsp;
           <span class="sub-menu sub-menu-text font-weight-bold">Custom Software Development</span>&nbsp;/&nbsp; -->
          <!-- <span class="sub-menu" routerLink="/about-us"> About Us</span> -->
        <!-- </h5>
      </div>
    </div> -->
   </div>
  <!--------------------------------------------------TITLE END-------------------------------------------->

 
<div class="bg-light">
    <!-- <div class="container p-4"> -->

        <!-- <div class="modal-body"> -->
            <!-- <button type="button" class="close" data-dismiss="modal">&times;</button> -->
            <div class="modal-body-content">
                <div class="container">
                <div class="row">
                    <!-- <div class="col-md-4 col-sm-12 col-xs-12">
                        <div class="profile-sidebar text-center">
                            <img src="./../../assets/img/contact/gnanaguru.jpg" class="rounded-circle modal-img" alt="" />
                        </div>
                    </div> -->
                    <div class="container d-flex justify-content-center align-items-center">
                        <div class="col-md-8 col-sm-12 col-xs-12 text-center">
                            <div class="pt-5">
                                <img src="./../../assets/img/activelogo.webp" width="5%" height="5%" alt="Active Multi Enterprises Logo" class="foot-logo">&nbsp;
                                <h2 class="font-weight-bolder">ACTIVE MULTI ENTERPRISES</h2>
                                <h5 style="color: black;">
                                    <i class="fa fa-phone" aria-hidden="true">&nbsp;<a class="" href="tel:9843683020">+91 84893 59948</a></i>
                                </h5>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            </div>
        <h4 class="font-weight-bolder align-middle text-center text-uppercase">
            Touch-With-US
          </h4>
        <!-- <div class="card"> -->
            <div class="row ">
                    <div class="col-lg-6 text-center w3-animate-left" style="padding-right: 0px;">
                        <div class="contact-detail">
                            <img src="./../../assets/img/contact/bg.jpg" alt="Notebook" class="contact-img">
                            <div class="content p-4">
                                <br /><br />
                                <h1 class="text-light align-middle" style="color: white;">LOCATION</h1>
                                <h4 class="align-middlefont-weight-bold">ACTIVE MULTI ENTERPRISES
                                    <sup >
                                        <i class="fa fa-registered" aria-hidden="true"></i>
                                    </sup>
                                    
                                </h4>
                                <p class="align-middle">
                                    No.84 Gangai Amman Koil Street, 
                                    <br />
                                    Near Amman Koil, Ayyapanthangal,
                                    <br />
                                    Chennai - 56, Tamilnadu, India.
                                </p>
                            
                                <h1 class="text-light">Phone | E-mail | Website</h1>
                                <p>
                                    <a class="mail-call" href="tel:9843683020">+91 84893 59948</a>
                                    <br />
                                    For General Enquiries: 
                                    <a class="mail-call" href="mailto:rvproduction2017@gmail.com">activemultienterprises@gmail.com</a>
                                    <br /><br>
                                    <br />
                                </p>
                                
                        </div>
                    </div>
                </div>
            </div>

            <br>
            <br>
<!--                 
                <div class="col-lg-6 text-center contact-field w3-animate-right ">
                    <h5 class="text-center font-weight-bold">Send Us A Message</h5>
                    <form  ngNativeValidate autocomplete="off" (ngSubmit)="submit1()">
                        <div class="form-row">
                            <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                <label for="inputEmail4">Name *</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1">
                                            <i class="fa fa-user icon" aria-hidden="true"></i>
                                        </span> 
                                    </div>
                                    <input type="name" class="form-control" id="inputEmail4" placeholder="Full Name" name="name" [(ngModel)]="this.contactus.name" required>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                <label for="inputEmail4">Mobile Number *</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1">
                                            <i class="fa fa-mobile icon" aria-hidden="true"></i>
                                        </span> 
                                    </div>
                                    <input type="tel" maxlength="10" class="form-control" id="inputEmail4"placeholder="Mobile number" name="mobile" [(ngModel)]="this.contactus.mobileNumber" required>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                <label for="inputEmail4">E-mail ID *</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fa fa-envelope  icon" aria-hidden="true"></i>
                                    </span> 
                                    </div>
                                    <input type="email" class="form-control" id="inputEmail4" placeholder="Email" name="email" [(ngModel)]="this.contactus.mailId" required>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                <label for="inputEmail4">Enquiry Title  *</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1">
                                            <i class="fa fa-file icon" aria-hidden="true"></i>
                                        </span> 
                                    </div>
                                    <input type="text" class="form-control" id="inputEmail4" name="enquiry" placeholder="Enquiry" [(ngModel)]="this.contactus.enquiryType" required>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                <label for="inputEmail4">Write a Message *</label>
                                <textarea class="form-control" name="message" placeholder="Message" [(ngModel)]="this.contactus.message" required>
                                </textarea>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                <button id="submit"></button>
                            </div>
                        </div>
                    </form>
                </div>
                     -->
				
			<!-- </div> -->
            
         <!-- </div> -->
    <!-- </div> -->
    <div class="container-fluid  bounceIn">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.7448326317553!2d80.2139650741217!3d13.051907413114424!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5266ec1ec0c44f%3A0xfadb075ac5417424!2s84%2C%20Gangaiamman%20Koil%20St%2C%20Vadapalani%2C%20Chennai%2C%20Tamil%20Nadu%20600026!5e0!3m2!1sen!2sin!4v1736591425523!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" width="100%" height="300" frameborder="0"  allowfullscreen="" >
        </iframe>
    </div>
</div>
</div>

<!--------------------------------------- MOBILE VIEW ------------------------------------------------->



 